
export function routerConfig(myApp) {

    require('authui/login2/controllers/login2Controller');
    require('authui/fpwd/controllers/fpwdController');
    require('authui/login/controllers/loginController');
    require('authui/loginverification/controllers/loginVerificationController');
    require('authui/casLoginError/controllers/casLoginErrorController');
    require('authui/upgrade/controllers/upgradeController');
    require('authui/error/controllers/errorController');
    require('authui/fphone/controllers/fPhoneController');
    require('authui/resetpwd/controllers/resetPwd');
    require('authui/welcomeemail/controllers/resetpwdController');
    require('authui/welcomeemail/controllers/failedController');
    require('authui/welcomeemail/controllers/resendController');
    require('authui/privacyUpdate/controllers/privacyUpdateController');
    require('authui/closecookie/controllers/closecookieController');
    require('authui/ssologin/controllers/ssologinController');
    require('authui/notify/controllers/notifyController');
    const bfController = require('authui/framework/controllers/bfController');

    const config = {
        hasHwid: "true"
    };
    const hasHwid = config.hasHwid === "true" ? true : false;
    // 统一id登录页和老登录页路由根据配置项true切换
    const routerList = [
        {
            name: hasHwid ? 'login2': 'login',
            url: hasHwid ? '/login2': '/login',
            views: {
                "content@": {
                    controller: 'authui.login2.ctrl',
                    template: require('authui/login2/views/content.html')
                },
                "banner@": {
                    controller: bfController,
                    template: require('authui/login2/views/banner.html')
                },
                "footer@": {
                    controller: bfController,
                    template: require('authui/framework/views/footer.html')
                }
            }
        },
        {
            name: "fpwd",
            url: "/fpwd",
            views: {
                "content@": {
                    template: require("authui/fpwd/views/content.html"),
                    controller: "authui.fpwd.ctrl"
                },
                'banner@': {
                    template: require('authui/fpwd/views/banner.html'),
                    controller: bfController
                },
                'footer@': {
                    template: require('authui/framework/views/footer.html'),
                    controller: bfController
                }
            }
        },
        {
            name: hasHwid ? 'login' : 'hwIDLogin',
            url: hasHwid ? '/login' : '/hwIDLogin',
            views: {
                "content@": {
                    template: require("authui/login/views/content.html"),
                    controller: "authui.login.ctrl"
                },
                'banner@': {
                    template: require('authui/login/views/banner.html'),
                    controller: bfController
                },
                'footer@': {
                    template: require('authui/login/views/footer.html'),
                    controller: bfController
                }
            }
        },
        {
            name: "loginVerification",
            url: "/loginVerification",
            views: {
                "content@": {
                    template: require("authui/loginverification/views/content.html"),
                    controller: "authui.loginVerification.ctrl"
                },
                'banner@': {
                    template: require('authui/loginverification/views/banner.html'),
                    controller: bfController
                },
                'footer@': {
                    template: require('authui/framework/views/footer.html'),
                    controller: bfController
                }
            }
        },
        {
            name: "fphone",
            url: "/fphone",
            views: {
                "content@": {
                    template: require("authui/fphone/views/content.html"),
                    controller: "authui.fphone.ctrl"
                },
                'banner@': {
                    template: require("authui/fphone/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "resetPwd",
            url: "/resetPwd",
            views: {
                "content@": {
                    template: require("authui/resetpwd/views/content.html"),
                    controller: "authui.resetPwd.ctrl"
                },
                'banner@': {
                    template: require("authui/resetpwd/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "welcomeLogin",
            url: "/welcomeLogin",
            views: {
                "content@": {
                    template: require("authui/welcomeemail/views/resetpwdContent.html"),
                    controller: "authui.welcomeLogin.ctrl"
                },
                'banner@': {
                    template: require("authui/welcomeemail/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "welEmailFailed",
            url: "/welEmailFailed",
            views: {
                "content@": {
                    template: require("authui/welcomeemail/views/failedContent.html"),
                    controller: "authui.welEmailFailed.ctrl"
                },
                'banner@': {
                    template: require("authui/welcomeemail/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "welEmailResend",
            url: "/welEmailResend",
            views: {
                "content@": {
                    template: require("authui/welcomeemail/views/resendContent.html"),
                    controller: "authui.welEmailResend.ctrl"
                },
                'banner@': {
                    template: require("authui/welcomeemail/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "closecookie",
            url: "/closecookie",
            views: {
                "content@": {
                    template: require("authui/closecookie/views/content.html"),
                    controller: "authui.closecookie.ctrl"
                },
                'banner@': {
                    template: require("authui/closecookie/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "privacyUpdate",
            url: "/privacyUpdate",
            views: {
                "content@": {
                    template: require("authui/privacyUpdate/views/content.html"),
                    controller: "authui.privacyUpdate.ctrl"
                },
                'banner@': {
                    template: require("authui/privacyUpdate/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "error",
            url: "/error",
            views: {
                "content@": {
                    template: require("authui/error/views/content.html"),
                    controller: "authui.error.ctrl"
                },
                'banner@': {
                    template: require("authui/error/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "upgrade",
            url: "/upgrade",
            views: {
                "content@": {
                    template: require("authui/upgrade/views/content.html"),
                    controller: "authui.upgrade.ctrl"
                },
                'banner@': {
                    template: require("authui/upgrade/views/banner.html"),
                    controller: bfController
                },
                'footer@': {
                    template: require("authui/framework/views/footer.html"),
                    controller: bfController
                }
            }
        },
        {
            name: "casLoginError",
            url: "/casLoginError",
            views: {
                "content@": {
                    template: require("authui/casLoginError/views/content.html"),
                    controller: "authui.casLoginError.ctrl"
                },
                'banner@': {
                    template: require('authui/casLoginError/views/banner.html'),
                    controller: bfController
                },
                'footer@': {
                    template: require('authui/framework/views/footer.html'),
                    controller: bfController
                }
            }
        },
        {
            name: "ssologin",
            url: "/ssologin",
            views: {
                "content@": {
                    template: require("authui/ssologin/views/content.html"),
                    controller: "authui.ssologin.ctrl"
                },
                'banner@': {
                    template: require('authui/ssologin/views/banner.html'),
                    controller: bfController
                },
                'footer@': {
                    template: require('authui/framework/views/footer.html'),
                    controller: bfController
                }
            }
        },
        {
            name: "notify",
            url: "/notify",
            views: {
                "content@": {
                    template: require("authui/notify/views/content.html"),
                    controller: "authui.notify.ctrl"
                },
                'banner@': {
                    template: require('authui/notify/views/banner.html'),
                    controller: bfController
                },
                'footer@': {
                    template: require('authui/framework/views/footer.html'),
                    controller: bfController
                }
            }
        },
    ];

    const routerConfig = ($stateProvider, $urlRouterProvider) => {
        $urlRouterProvider.otherwise('/login');
        for (let config of routerList) {
            $stateProvider.state(config);
        }
    };

    routerConfig.$inject = ['$stateProvider', '$urlRouterProvider'];

    myApp.config(
        routerConfig
    );
}


// WEBPACK FOOTER //
// ./public/hws/routerConfig.js